import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
import LazyLoad from 'react-lazyload';
import NavTop from '../../containers/NavTop/NavTop';
import ContactSection from '../../containers/ContactSection/ContactSection';
import EmbedYouTubeVideo from '../../common/EmbedYouTubeVideo/EmbedYouTubeVideo'; 
import MarketGrowthSection from '../../containers/MarketGrowthSection/MarketGrowthSection';
import './VideosPage.css';
import { Collapse, BackTop, Row, Col } from 'antd';
const Panel = Collapse.Panel;

var obj_text = [
  {
    "title":"Are you currently marketing a device?",
    "body":"<p>No, we are not currently marketing a device.</p> <p>We are seeking technology and business partners to fulfill the vision of our intellectual property. </p>        <p>Real Time Touch will be working with these partners to develop and market a variety of \r\n telemedicine and teletherapy devices. Currently, we have been granted by the USPTO rights under the patent \"Powered Physical Displays \r\n  on Mobile Devices\" 9,639,150 and have patents pending -- see more on our <a href=\"/patents/\">Patents page</a></p><p>If you would like to contribute or discuss our inventions and patents, please feel free to contact us via the <a href\"/contact/\"></a>contact form</a></p>"
  },
  {
    "title":"What patents have been granted for Real Time Touch technology?",
    "body":"<p>The USPTO has granted the patent for Powered Physical Displays on Mobile Devices 9,639,150.</p><p>Current publication date of full granted patent May 2, 2017. Prior publication of the patent application was Nov 6, 2008 under Application number US 20080274769 A1.</p><p>Real Time Touch also has a pending patent with additional claims building from the granted patent. Application #20170195624 contains claims on GPS, biometrics, Virtual Reality and many other relevant features.</p><p>We also have an additional patent pending for GPS & location-based marketing.</p>"
  },
  {
    "title":"What is a brief description for the USPTO granted patent 9,639,150 Powered physical displays on mobile devices ? ",
    "body":"<p><b>The following is the abstract for Powered physical displays on mobile devices 9,639,15</b></p><p>\"In certain embodiments, a mobile electronic apparatus for facilitating live physical communications with a remote person includes a transducer configured to sense a physical gesture performed by a user of the device; a physical display apparatus configured to convert energy into physical movement; a processor operatively connected to the transducer and to the physical display apparatus, the processor configured to generate an output signal corresponding to the physical gesture and to interpret an input signal to determine a physical action associated with an input signal; and a communications interface configured to send output signals to a data network and to receive input signals from said data network.</p><p>In some embodiments, the physical display system is configured to produce the physical action substantially immediately after the input signal is received.\" </p>"
  },
  {
    "title":"Why will Real Time Touch's (\"RTT\") Augmented Telemedicine and Teletherapy devices revolutionize remote\r\n        care? ",
    "body":"<p>RTT technology is a more complete package by delivering remotely supervised treatments, therapies \r\n        and the release of medicine.</p>  <p>The four legs of the RTT </p> <p>1) videoconferencing;</p><p>2) real-time vitals;</p>\r\n <p>3) triaging;</p><p>4) if appropriate tele-treatment/therapy and or medications;</p> <p>5) if required, assist emergency medical services, life-flight, hospital transport.</p>"
  },
  {
    "title":"Who is the inventor of Real Time Touch technology?",
    "body":"<p>Real Time Touch's patents are assigned to Craig Linden.</p> <p>You can contact him via our <a href=\"/contact/\">contact page</a> and he is also active on <a href=\"https://twitter.com/RttCraig\">Twitter</a> and LinkedIn</p>"
  },
  {
    "title":"What functions can be performed using RTT's augmented Telemedicine and TeleTriage methods?",
    "body":"<p>The Real Time Touch provides for face2face communication between the client (or client helper)\r\n    and a doctor, RN or other qualified specialist.  Real-time vital signs, test results, patient history, \r\n    securely transferred for diagnosis. Treatment is recommended and preformed with real-time\r\n    and ongoing monitoring with appropriate feedback.</p>"
  },
  {
    "title":"What types of IoT medical and therapy devices will your partners develop?",
    "body":" <p>For a limited example, devices that can be more safely used when controlled and \r\n  monitored by a qualified caregiver such as FDA cleared and/or FDA approved technologies \r\n  that may include:</p> <ul class=\"content-ul\"><li>TMS (transcranial magnetic stimulation);</li> <li>TENS devices (transcutaneous electrical\r\n  stimulation);</li> <li>PEMF & LFMS magnetic therapy devices;</li> <li>Thermal, Infrared and other light-based devices;</li>\r\n <li>RF (radio frequency) devices; Ultrasound devices; </li><li>Motion/movement and other physical output devices;</li><li>\r\n  and remote controlled Rx vaults with verification.</li></ul> "
  },
  {
    "title":"How do I contact Real Time Touch?",
    "body":"<p>Please contact us on our <a href=\"/contact\">contact page</a></p>"
  },
  {
    "title":"Are you accepting Partnerships or hiring to grow Real Time Touch ?",
    "body":"<p>Right now, we are an early stage startup and are not currently developing or producing devices. However we \r\n        would be interested in discussions regarding potential partnerships, both for technical and business development. \r\n        We are not hiring, but could discuss potential partnership arrangements if mutually beneficial.\r\n        \r\n        Please contact us on our <a href=\"/contact\">contact page</a></p>"
  },
  {
    "title":"What are the most important claims of your intellectual property and patent?",
    "body":"<p>There are 36 claims in patent number 9,639,150.</p> <p>The first claim states: A method for treating a patient comprising steps of:</p><p> providing a first device at a patient location, the first device being an internet and networking capable multi-media mobile electronic device comprising at least one each of a physical output display and an input transducer; </p><p>providing a second device at a remote location, wherein the second device is distinct and separate from the first device; </p><p>establishing an audio-video and data communication connection between the patient location and the remote location; </p><p>conducting an audio-video conference between the patient at the patient location and a treatment provider at the remote location, wherein the audio-video conference comprises the treatment provider eliciting patient information by verbally interacting with the patient; </p><p>transmitting the patient information from the first device to the second device by way of the audio-video conference; </p><p>using the input transducer to measure a patient parameter at the patient location and produce a first signal indicative of the patient parameter, wherein the patient parameter includes at least one vital sign;</p><p>transmitting the first signal to the second device; </p><p>forming a diagnosis at least partially based on the patient parameter; </p><p>using the first signal at the remote location, the diagnosis and the patient information transmitted before, during or after the audio-video conference to determine a treatment and generating a second signal associated with said treatment;</p><p>sending said second signal from said second device to said first device to administer a treatment; </p><p>and using said second signal to cause a physical interaction between the physical output display and the patient. </p>"
  },
];

class VideosPage extends Component {

  constructor(props){
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  
  renderPanel = () => {

    return obj_text.map((item,i)=>
      <Panel class="VideosPage--panel-header" header={obj_text[i].title} key={i}>
       <div dangerouslySetInnerHTML={{__html: obj_text[i].body}}></div>
      </Panel>
    )

  }


  render(){ 
    return (
      <Fragment>
        <Helmet>
            <meta charSet="utf-8" />
            <title>RealTimeTouch.com - Videos</title>
            <link rel="canonical" href="http://www.realtimetouch.com/videos/" />
        </Helmet>
        <NavTop pageOn={this.props.pageOn}/>
        <BackTop />
        <div className="VideosPage--subnavbar-container">
          <div className="VideosPage--subnavbar center">
          </div>  
          <div className="VideosPage--subnavbar2 center">
          </div>
          <h2 className="VideosPage--subnavbar-headline font-special-heading">Real Time Touch / Telemedicine Videos</h2>
        </div>
          <div className="VideosPage--container center">

            <div className="VideosPage--headline-container">
              <h3 className="VideosPage--subheadline">View videos about exciting Real Time Touch and Telemedicine-related Technologies</h3>
              <h5 className="VideosPage--body">Millions of Medical Providers and Patients will be using Telehealth solutions. Real Time Touch is strategically positioned to develop these solutions, with key intellectual property rights. Join with us in this exciting new Distributed Health human and environmental friendly development.</h5>
              <h5 style={{marginTop:10}}>View videos below!<br /></h5>

            </div>
            {/* <Divider /> */}

            <div className="VideosPage--collapse-container">
 
              <div className="gutter-example">

                <Row>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                    <div class="card">
                      <div class="header">
                      <EmbedYouTubeVideo width="400" type="short" video="dHhTkEQCorc" title=""/>
                      </div>

                      <div class="container">
                        <p>Helping Seniors - Real Time Touch</p>
                      </div>
                    </div>                    
                    
                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="VXkrDXk5rmo" title=""/>
                        </div>

                        <div class="container">
                          <p>Reducing Readmissions - Real Time Touch </p>
                        </div>
                      </div>     

                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="OegPSItsfwM" title=""/>
                        </div>

                        <div class="container">
                          <p>Reducing Opioid Dependences - Real Time Touch </p>
                        </div>
                      </div>     

                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                    <div class="card">
                      <div class="header">
                      <EmbedYouTubeVideo width="400" type="short" video="gYSoNX6aDbw" title=""/>
                      </div>

                      <div class="container">
                        <p>Decentralizing Clinical Trials - Real Time Touch </p>
                      </div>
                    </div>                    
                    
                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="vKLN7btr8m8" title=""/>
                        </div>

                        <div class="container">
                          <p>Real Time Touch is strategically positioned</p>
                        </div>
                      </div>     

                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                    <div class="card">
                      <div class="header">
                      <EmbedYouTubeVideo width="400" type="short" video="rsb5dVsbF9w" title=""/>
                      </div>

                      <div class="container">
                        <p>Real Time Touch: Emergency Telemedicine</p>
                      </div>
                    </div>                    
                    
                    </div>
                  </Col>
                </Row>


              <LazyLoad>

                <Row>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                    <div class="card">
                      <div class="header">
                      <EmbedYouTubeVideo width="400" type="short" video="u1-MFo7_n-Y" title=""/>
                      </div>

                      <div class="container">
                        <p>PBS Telemedicine Special</p>
                      </div>
                    </div>                    
                    
                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="HDuaiVXaz6o" title=""/>
                        </div>

                        <div class="container">
                          <p>ATA Telemedicine Executive Interview</p>
                        </div>
                      </div>     

                    </div>
                  </Col>
                  <Col className="gutter-row" sm={24} md={8}>
                    <div className="gutter-box">
                    
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="t8nNmBjW16g" title=""/>
                        </div>

                        <div class="container">
                          <p>Justin Kahn | TEDxSaltLakeCity</p>
                        </div>
                      </div>     

                    </div>
                  </Col>
  
                </Row>

                

                  <Row>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="hvif1C4gwm4" title=""/>
                        </div>

                        <div class="container">
                          <p>ComHIP and telemedicine</p>
                        </div>
                      </div>                    
                      
                      </div>
                    </Col>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                        <div class="card">
                          <div class="header">
                          <EmbedYouTubeVideo width="400" type="short" video="HvQM1O0sxNA" title=""/>
                          </div>

                          <div class="container">
                            <p>Healthcare Innovation</p>
                          </div>
                        </div>     

                      </div>
                    </Col>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                        <div class="card">
                          <div class="header">
                          <EmbedYouTubeVideo width="400" type="short" video="4LW_shT9yzU" title=""/>
                          </div>

                          <div class="container">
                            <p>Telemedicine For Rural Communities</p>
                          </div>
                        </div>     

                      </div>
                    </Col>
    
                  </Row>


                  <Row>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                      <div class="card">
                        <div class="header">
                        <EmbedYouTubeVideo width="400" type="short" video="ukjzzBZxS9w" title=""/>
                        </div>

                        <div class="container">
                          <p>Why I left the Hospital System</p>
                        </div>
                      </div>                    
                      
                      </div>
                    </Col>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                        <div class="card">
                          <div class="header">
                          <EmbedYouTubeVideo width="400" type="short" video="47LnUsYo1yY" title=""/>
                          </div>

                          <div class="container">
                            <p>TedX:Monga Telemedicine</p>
                          </div>
                        </div>     

                      </div>
                    </Col>
                    <Col className="gutter-row" sm={24} md={8}>
                      <div className="gutter-box">
                      
                        <div class="card">
                          <div class="header">
                          <EmbedYouTubeVideo width="400" type="short" video="9we789BFxRM" title=""/>
                          </div>

                          <div class="container">
                            <p>D:Heart the Future of Telemedicine</p>
                          </div>
                        </div>     

                      </div>
                    </Col>
    
                  </Row>

                </LazyLoad>

              </div>

{/* 
              <div className="">
              Millions of Medical Providers and Patients will be using Telehealth solutions. Real Time Touch is strategically positioned to develop these solutions, with key intellectual property rights. Join with us in this exciting new Distributed Health human and environmental friendly development.
              </div> */}


            </div>

            <MarketGrowthSection  background="none" />

            <ContactSection background="none" />

          </div>
        </Fragment>
    )
  }
}
 
 
 export default VideosPage;


// WEBPACK FOOTER //
// ./src/pages/VideosPage/VideosPage.js